module.exports = __webpack_public_path__ + "71a638b271a1ca0081322c9606973508.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/checkout/en/cib_bank.png
// module id = ./app/images/checkout/en/cib_bank.png
// module chunks = 40